import { render, staticRenderFns } from "./my_credit.vue?vue&type=template&id=56cdbe20&scoped=true"
import script from "./my_credit.vue?vue&type=script&lang=js"
export * from "./my_credit.vue?vue&type=script&lang=js"
import style0 from "./my_credit.vue?vue&type=style&index=0&id=56cdbe20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdbe20",
  null
  
)

export default component.exports